<template>
    <form class="" method="post" @submit="checkForm">
      <h2 class="h3">
       {{ header }}
      </h2>
      <p>Login: <strong>{{ login }}</strong></p>
      <div class=" mb-2 input-group icon icon__key">
              <input type="password" class="form-control"  :placeholder="haslo" :aria-label="haslo" name="password" @input="password_check" v-model="password">
      </div>
      <div>
        <p class="frmValidation" :class="{'frmValidation--passed' : password.length > 7 && password.length <= 32}"><i class="frmIcon bi" :class="password.length > 7 && password.length <= 32 ? 'bi-check' : 'bi-x'"></i> {{dlugosc}}</p>
        <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase || checkCount()}"><i class="frmIcon bi" :class="has_uppercase ? 'bi-check' : 'bi-x'"></i> {{wielk}}</p>
        <p class="frmValidation" :class="{'frmValidation--passed' :has_lowercase || checkCount()}"><i class="frmIcon bi" :class="has_lowercase ? 'bi-check' : 'bi-x'"></i> {{mala}}</p>
        <p class="frmValidation" :class="{'frmValidation--passed' : has_number || checkCount()}"><i class="frmIcon bi" :class="has_number ? 'bi-check' : 'bi-x'"></i> {{cyfra}}</p>
        <p class="frmValidation" :class="{'frmValidation--passed' : has_special || checkCount()}"><i class="frmIcon bi" :class="has_special ? 'bi-check' : 'bi-x'"></i> {{znak}}</p>        
      </div>
      <div class=" mb-2 input-group icon icon__key">
              <input type="password" class="form-control"  :placeholder="powtorz" :aria-label="powtorz" name="password_repeat"  v-model="password_repeat">
      </div>
      <div>
        <p class="frmValidation" :class="{'frmValidation--passed' : password.length> 1 && password == password_repeat}"><i class="frmIcon bi" :class="password.length> 1 && password == password_repeat ? 'bi-check' : 'bi-x'"></i> {{zgodnosc}}</p>
      </div>
      <button type="submit" class="btn btn-warning w-100  mb-2" :disabled="isDisabled">{{zmien}}</button>
    </form>

</template>
<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import DateTime from './inputs/date-time';

import 'vue2-datepicker/index.css';

export default {
  name: 'password-change',
  props: {
    login: String,
    header:String,
    haslo:String,
    powtorz:String,
    dlugosc:String,
    wielk:String,
    mala:String,
    cyfra:String,
    znak:String,
    zgodnosc:String,
    zmien:String,
  },
  components: {
    VueTypeaheadBootstrap,
    DateTime
  },
  data() {
    return {
      password: '',
      password_repeat: '',
      has_number:    false,
      has_length:    false,
      has_lowercase: false,
      has_uppercase: false,
      has_special:   false,    
    }
  },
  computed: {
    isDisabled () {
        return (!this.has_length || !this.checkCount() || this.password != this.password_repeat);
    }
  },  
  methods: {
    checkForm: function (e) {
        if(!this.has_length || !this.checkCount() || this.password != this.password_repeat) e.preventDefault();
        return true;
    },
    checkCount:function(){
      let c = 0;
      if(this.has_number) c++;
      if(this.has_lowercase) c++;
      if(this.has_uppercase) c++;
      if(this.has_special) c++;
      if(c>=3) return true; else return false;
    },
    password_check: function () {
                    this.has_length    = this.password.length > 7 && this.password.length <= 32;
                    this.has_number    = /\d/.test(this.password);
                    this.has_lowercase = /[a-z]/.test(this.password);
                    this.has_uppercase = /[A-Z]/.test(this.password);
                    this.has_special   = /[●!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(this.password);
    }
  }
}

</script>
<style>
        .frmValidation{font-size: 13px; }
        .frmValidation--passed{color:#717b85;}
        .frmIcon{color:#EB0029;}
        .frmValidation--passed .frmIcon{color:#0fa140;}  
</style>